import { Typography } from '@mui/material';
import { ListCarousel } from 'components/ListCarousel/ListCarousel';
import Product from 'components/Product/Product';
import { useGetCustomerConsultantFavouritesQuery } from 'generated/graphql';
import { useServerTranslation } from 'hooks/useServerTranslation';

export default function OrganisationHome() {
    const { t } = useServerTranslation();

    const { data, loading, error } = useGetCustomerConsultantFavouritesQuery();

    const consultantFavourites = data?.customerConsultantFavourites?.items;

    if (loading || error || !consultantFavourites?.length) {
        return null;
    }

    return (
        <>
            <Typography variant="h1" fontSize={32} textAlign="center" marginY={2}>
                {t('organisation-home.favourites')}
            </Typography>
            <ListCarousel
                items={consultantFavourites.map((product) => (
                    <Product
                        key={product.id}
                        boxProps={{ width: '240px', marginX: 1.5 }}
                        product={product}
                    />
                ))}
                listWrapperStyle={{ marginBottom: 3, flex: 1 }}
            />
        </>
    );
}
